import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Form, DropdownButton } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTraitApi, deleteTraitApi, toggleTraitPublishedStateApi } from './traitSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import 'tippy.js/dist/tippy.css'; // optional for styling
import Datatable from '~/components/Datatable';
import { titleCase } from '~/utils/helpers';

function Trait() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.heroSaga.trait);
    const { types } = useSelector((state) => state.heroSaga.trait);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
            },
            {
                name: 'Name',
                sortable: true,
                cell: (row) => {
                    return <div>{row.name}</div>;
                },
            },
            {
                name: 'Type',
                sortable: true,
                cell: (row) => titleCase(row.type),
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        row={row}
                        thunkFunc={deleteTraitApi}
                        queryParam={`?type=${row.type}`}
                    />
                ),
            },
            {
                name: 'Published',
                cell: (row) => (
                    <Form.Check
                        type="switch"
                        id={'published-' + row.id}
                        onChange={() => {
                            dispatch(toggleTraitPublishedStateApi(row.id));
                        }}
                        checked={row.isReady}
                    />
                ),
                maxWidth: '5rem',
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchTraitApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <DropdownButton
                    id="dropdown-create-new"
                    title="Create"
                    variant="info"
                >
                    {types.map((type) => (
                        <Link
                            key={type}
                            to={`create?type=${type}`}
                            className="dropdown-item"
                        >
                            {titleCase(type)}
                        </Link>
                    ))}
                </DropdownButton>
            </div>
            <div className="col-sm-7 offset-sm-2">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default Trait;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don"t use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
